<template>
  <div class="modal-kajabi">
    <hr />
    <bp-select
      id="product-select"
      label="Nome do produto"
      class="my-3"
      v-model="form.product_id"
      placeholder="Selecionar produto"
      :disabled="isEdit"
      :options="products.map(({ id, name }) => ({ id, name }))"
      required
    />
    <!-- <action-dispatcher
      v-if="form.product_id"
      :key="form.product_id"
      :action="isSignature ? 'plan/get' : 'offer/get'"
      :parameters="{ product_id: form.product_id, limit: 1000 }"
    >
      <form-group
        select
        id="offers"
        label="Oferta"
        v-model="form.offer"
        placeholder="Selecionar plano/oferta..."
        :options="allOffers"
      />
    </action-dispatcher> -->
    <div class="row mb-5">
      <div class="col-lg-6">
        <bp-input
          id="url_activation"
          label="Informe a URL para ativação de novo membro"
          v-model="form.url_activation"
          placeholder="Digite a URL"
          required
        />
      </div>
      <div class="col-lg-6">
        <bp-input
          id="url_deactivation"
          label="Informe a URL para desativação de membro"
          v-model="form.url_deactivation"
          placeholder="Digite a URL"
          required
        />
      </div>
    </div>

    <div class="submit-buttons">
      <bp-button
        color="neutral"
        variant="filled-1"
        label="Cancelar"
        @click="$emit('close')"
      />
      <bp-button
        label="Integrar"
        :loading="loading"
        :disabled="!isValid"
        @click="submit"
      />
    </div>
  </div>
</template>
<script>
// import { defaultOffer } from "@/functions/product.js";
import { formFields } from "@/functions/helpers";
import IntegrationModalMixin from "@/mixins/integrationModal";
export default {
  mixins: [IntegrationModalMixin],
  data() {
    return {
      ...formFields(
        ["product_id", "offer", "url_activation", "url_deactivation"],
        {
          ...this.integrationToEdit,
          product_id: this.integrationToEdit?.product?.id
        }
      )
    };
  },
  computed: {
    // ...mapState("plan", ["plans"]),
    // ...mapState("offer", ["offers"]),
    focusedProduct() {
      if (!this.form.product_id) {
        return null;
      }
      return this.products.find(p => p.id === this.form.product_id);
    },
    isValid() {
      return (
        this.form.product_id &&
        // this.form.offer !== null &&
        this.form.url_activation &&
        this.form.url_deactivation
      );
    }
    // isSignature() {
    //   if (this.focusedProduct) {
    //     return this.focusedProduct.type_product === "signature";
    //   }
    //   return false;
    // },
    // allOffers() {
    //   if (!this.focusedProduct) return [];

    //   if (this.isSignature) {
    //     return this.plans;
    //   } else {
    //     const default_offer = defaultOffer(this.focusedProduct);
    //     return [default_offer, ...this.offers];
    //   }
    // }
  },
  methods: {
    submit() {
      this.loading = true;
      if (this.integrationToEdit) {
        this.$store
          .dispatch("integration/putKajabi", {
            product_id: this.product_id,
            id: this.integrationToEdit.id,
            ...this.form
          })
          .then(this.onSuccess)
          .catch(() => {
            this.$message.error("Erro ao salvar integração");
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$store
          .dispatch("integration/postKajabi", {
            product_id: this.product_id,
            ...this.form
          })
          .then(this.onSuccess)
          .catch(error => {
            this.$message.error("Erro ao salvar a nova integração");
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
};
</script>
